<template>
    <v-form
        v-model="form_valid"
        @submit.prevent
    >
        <VPhoneInput
            v-model="internal_input"
            :country-label="translate(country_label)"
            :exclude-countries="exclude_countries"
            :include-countries="include_countries"
            :invalid-message="translate(invalid_message)"
            :label="translate(label)"
            :prefer-countries="preferred_countries"
            :rules="rules"
            country-icon-mode="svg"
            default-country="SE"
            variant="outlined"
            guess-country
        />
    </v-form>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import 'flag-icons/css/flag-icons.min.css'
import 'v-phone-input/styles'
import { VPhoneInput } from 'v-phone-input'
import { locales_mixin } from '@old/mixins/locales_mixin/index.js'

export default {
    name: 'PhoneField',
    props: {
        input: String,
        valid: Boolean,
        required: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: 'common.phone_number',
        },
        country_label: {
            type: String,
            default: 'common.country',
        },
        invalid_message: {
            type: String,
            default: 'common.invalid_phone_number',
        },
        preferred_countries: {
            type: Array,
            default: () => {
                return ['SE']
            },
        },
        include_countries: {
            type: Array,
            default: () => {
                return []
            },
        },
        exclude_countries: {
            type: Array,
            default: () => {
                return []
            },
        },
    },
    mixins: [locales_mixin],
    components: {
        VPhoneInput,
    },
    data() {
        return {
            form_valid: false,
        }
    },
    computed: {
        rules() {
            return this.required ? [(value) => Boolean(value) || this.translate('common.required')] : []
        },
        is_valid() {
            return Boolean(this.form_valid)
        },
        internal_input: {
            get() {
                return this.input
            },
            set(value) {
                this.$emit('update:input', value)
            },
        },
        internal_valid: {
            get() {
                return this.valid
            },
            set(value) {
                this.$emit('update:valid', value)
            },
        },
        ...mapGetters([]),
        ...mapState([]),
    },
    watch: {
        is_valid: {
            handler(value) {
                this.internal_valid = value
            },
            immediate: true,
        },
    },
    methods: {
        ...mapActions([]),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped></style>
